import React, { useEffect, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';

export function UpdateTrackingDialog(props) {
  const { open, onClose, onSave, value } = props;

  const [tracking, setTracking] = useState('');

  const handleClose = () => {
    onClose();
  };

  const handleSave = () => {
    onSave(tracking);
    handleClose();
  };

  useEffect(() => {
    if (open) {
      setTracking(value);
    }
  }, [open, value]);

  return (
    <Dialog
      aria-labelledby="form-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      onClose={handleClose}
      open={open}
    >
      <DialogTitle id="form-dialog-title">Update tracking number</DialogTitle>

      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          id="tracking"
          label="Tracking number"
          margin="dense"
          onChange={event => setTracking(event.target.value)}
          type="text"
          value={tracking}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
